import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "@teamprevent/common/healthSurveillance";

import * as questionIds from "./questionIds";

const medicalTypes = [
    MedicalTypeIds.BiologicalMonitoring
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../consultation";` which is in a data structure suitable for use with custom medicals
 */
export const biologicalMonitoringQuestions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.BiologicalMonitoringUnableToCarryOut,
        questionText: "Unable to carry out medical",
        medicalTypes
    },
    {
        id: questionIds.BiologicalMonitoringUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
        medicalTypes
    },
    {
        id: questionIds.BiologicalMonitoringSampleTaken,
        questionText: "Type of Sample taken",
        medicalTypes
    },
    {
        id: questionIds.BiologicalMonitoringSampleTakenOtherDetails,
        questionText: "Give details",
        medicalTypes
    },
    {
        id: questionIds.BiologicalMonitoringSubstancesBeingTestedFor,
        questionText: "Details of substance(s) being tested for",
        medicalTypes
    },
    {
        id: questionIds.BiologicalMonitoringLaboratorySentTo,
        questionText: "Details of Laboratory the sample has been sent to",
        medicalTypes
    },
    {
        id: questionIds.BiologicalMonitoringClinicalNotes,
        questionText: "Clinical Notes",
        medicalTypes
    },
];
